import React, { useState } from "react";
import { Routes, Route, useParams, useNavigate } from "react-router";
import { useComponentTranslation } from "@/services/i18n";
import toast from "react-hot-toast";
import IndeedPage from "./indeed";
import LinkedInPage from "./linkedin";
import GoogleForJobsPage from "./google-for-jobs";
import QRCodePage from "./qrcode";
import CustomChannelPage from "./custom-channel";
import LinkedInSharePage from "./linkedin-share";
import FacebookSharePage from "./facebook-share";
import XSharePage from "./x-share";
import IframePage from "./iframe";
import JobegoPage from "./jobego";
import Recommendations from "./recommendations";
import DistributionHub from "./DistributionHub";
import NewChannel from "./NewChannel";
import PostDetail from "./post-detail";
import API from "@/services/api";
import useStore from "@/services/store";

export default function Distribution({ job, setJob, posts = [], setPosts }) {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="p-5">
      <Routes>
        <Route path="indeed" element={<IndeedPage job={job} setJob={setJob} posts={posts} setPosts={setPosts} />} />
        <Route path="linkedin" element={<LinkedInPage job={job} setJob={setJob} posts={posts} setPosts={setPosts} />} />
        <Route path="google-for-jobs" element={<GoogleForJobsPage job={job} setJob={setJob} posts={posts} setPosts={setPosts} />} />
        <Route path="qr-code" element={<QRCodePage job={job} setJob={setJob} posts={posts} setPosts={setPosts} />} />
        <Route path="share-on-linkedin" element={<LinkedInSharePage job={job} setJob={setJob} posts={posts} setPosts={setPosts} />} />
        <Route path="share-on-facebook" element={<FacebookSharePage job={job} setJob={setJob} posts={posts} setPosts={setPosts} />} />
        <Route path="share-on-x" element={<XSharePage job={job} setJob={setJob} posts={posts} setPosts={setPosts} />} />
        <Route path="iframe" element={<IframePage job={job} setJob={setJob} posts={posts} setPosts={setPosts} />} />
        <Route path="jobego" element={<JobegoPage job={job} setJob={setJob} posts={posts} setPosts={setPosts} />} />

        {/* Add Channel Marketplace */}
        <Route path="new" element={<NewChannel job={job} posts={posts} setPosts={setPosts} />} />

        {/* Post Detail by ID */}
        <Route path="post/:postId" element={<PostDetail />} />

        {/* Recommendations Route */}
        <Route path="recommendations" element={<Recommendations job={job} posts={posts} setPosts={setPosts} />} />

        <Route path=":slug" element={<CustomChannelPage job={job} setJob={setJob} posts={posts} setPosts={setPosts} />} />
        <Route index element={<DistributionHub job={job} setJob={setJob} posts={posts} setPosts={setPosts} />} />
        <Route path="*" element={<DistributionHub job={job} setJob={setJob} posts={posts} setPosts={setPosts} />} />
      </Routes>
    </div>
  );
}
